/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
.ux-notification-text {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ux-notification-text__wrapper_expanded {
  max-height: unset !important;
  overflow: unset !important;
}

.ux-notification-text__wrapper_gradient::before {
  content: "";
  width: 100%;
  height: 114px;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgb(255, 255, 255));
}
@media (min-width: 1440px) {
  .ux-notification-text__wrapper_gradient::before {
    height: 150px;
  }
}

.ux-notification-text__icon {
  transform: rotate(180deg);
}

.ux-notification-text__wrapper {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  max-height: 114px;
  overflow: hidden;
}
@media (min-width: 1440px) {
  .ux-notification-text__wrapper {
    max-height: 150px;
  }
}
.ux-notification-text__wrapper .ux-notification-text__error {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  color: #ff0201;
  font-size: 13px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.ux-notification-text__wrapper .ux-notification-text__subject {
  margin-bottom: 4px;
}
@media (min-width: 1440px) {
  .ux-notification-text__wrapper .ux-notification-text__subject {
    margin-bottom: 6px;
  }
}
.ux-notification-text__wrapper .ux-notification-text__message {
  color: var(--ux-notification-item-text-color);
}
.ux-notification-text__wrapper .ux-notification-text__message .ux-text-link {
  white-space: nowrap;
}

.ux-notification-item--information .ux-notification-text__subject {
  color: #131313;
}

.ux-notification-item--warning .ux-notification-text__subject {
  color: #ff9302;
}

.ux-notification-item--error .ux-notification-text__subject {
  color: #ff0201;
}